/**
 * Gig impression source page.
 */
export const GIG_IMPRESSION_SOURCE_PAGE = 'certified_banner';

/**
 * Mixpanel Banner event types.
 */
export enum MixpanelBannerEventType {
    /**
     * When CertifiedBanner is clicked.
     */
    Click = 'Certified banner clicked',
    /**
     * When CertifiedBanner is shown.
     */
    Show = 'Certified banner showed',
}

/**
 * BigQuery Banner event types.
 */
export enum BigQueryBannerEventType {
    /**
     * When CertifiedBanner is clicked.
     */
    Click = 'click_certified_listing_banner',
    /**
     * When CertifiedBanner is shown.
     */
    Show = 'certified_listing_banner_is_shown',
}
